import { generateTranslations } from '../../i18n/translation';

const translations = generateTranslations('agreementduplicatewarning', {
  tilSagtOpp: {
    nb: 'den sies opp',
    en: 'it is terminated',
  },
  modalTitle: {
    nb: 'Advarsel: Det finnes { antall } overlappende avtaler',
    en: 'Warning: There are { antall } duplicate agreements',
  },
  subtitle: {
    nb: 'Overlappende avtaler kan forårsake problemer når man setter opp bestillinger eller besvarelser i praksisaktiviteter. Overlappende avtaler bør derfor unngås. Overlapp skjer når en avtale er innenfor samme tidsperiode, ved samme studiested, med samme praksistype og samme praksissted, som en eksisterende avtale.',
    en: 'Duplicated agreements may cause problems when organizing orders and responses in practice activities, and one should therefore avoid having them. For an agreement to be considered a duplicate it must share institution, period, practice type and practice place with an existing agreement.',
  },
  fantOverlappendeAvtaleTitle: {
    nb: 'Overlappende avtaler:',
    en: 'Duplicate practice place agreements:',
  },
  periodeLabel: {
    nb: 'Periode: ',
    en: 'Period: ',
  },
  periodeFormat: {
    nb: '{ avtalestart } til { avtaleslutt }',
    en: '{ avtalestart } until { avtaleslutt }',
  },
  praksistyperLabel: {
    nb: 'Praksistype(r): ',
    en: 'Practice type(s): ',
  },
  avtalestederLabel: {
    nb: 'Problematisk(e) avtalestede(r) i den overlappende avtalen: ',
    en: 'Problematic agreement place(s) in the duplicated agreement: ',
  },
  submitLabel: {
    nb: 'Bekreft lagring av overlappende avtale',
    en: 'Confirm saving duplicated agreement',
  },
});

export default translations;
